<template>
    <main class="flex h-screen w-screen items-center justify-center">
        <LoadingAnimation :text="$t('auth.logout')" />
    </main>
</template>

<script setup lang="ts">
    import { RouteNames } from '@/router/routeNames';
    import { onMounted } from 'vue';
    import { useRouter } from 'vue-router';

    const router = useRouter();

    onMounted(() => {
        void router.replace({ name: RouteNames.Index });
    });
</script>
